export default __webpack_public_path__ + "static/media/wrong-way.be339b52.svg";